// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cell-image-image-Hhqwn {
  width: 36px;
  height: 36px;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/cell-image/cell-image.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB","sourcesContent":[".image {\n  width: 36px;\n  height: 36px;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `cell-image-image-Hhqwn`
};
export default ___CSS_LOADER_EXPORT___;
